export default "__VITE_PUBLIC_ASSET__b8ef1db6__"